class CurrencyUtils {
    static format(value, currency = 'PLN') {
      const formatter = new Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      
      if (!value) {
        return formatter.format('0');
      }      
      return formatter.format(value);
    }
}

export default CurrencyUtils;
